import React from 'react';
import Icon from '../../../components/AppIcon';

const EMIRATES = [
  { value: 'all', label: 'All Emirates' },
  { value: 'dubai', label: 'Dubai' },
  { value: 'abu-dhabi', label: 'Abu Dhabi' },
  { value: 'sharjah', label: 'Sharjah' },
  { value: 'ajman', label: 'Ajman' },
  { value: 'ras-al-khaimah', label: 'Ras Al Khaimah' },
  { value: 'fujairah', label: 'Fujairah' },
  { value: 'umm-al-quwain', label: 'Umm Al Quwain' },
];

const REPORT_PERIODS = [
  { value: '2025-02', label: 'February 2025' },
  { value: '2025-01', label: 'January 2025' },
  { value: '2024-12', label: 'December 2024' },
  { value: '2024-11', label: 'November 2024' },
  { value: '2024-10', label: 'October 2024' },
  { value: '2024-09', label: 'September 2024' },
];

const EmirateSelector = ({ selectedEmirate, onEmirateChange, selectedPeriod, onPeriodChange, onGenerate, isGenerating }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between">
      <div className="flex flex-col sm:flex-row gap-3 flex-1">
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Emirate</label>
          <select
            value={selectedEmirate}
            onChange={(e) => onEmirateChange(e?.target?.value)}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 min-w-[160px]"
          >
            {EMIRATES?.map((e) => (
              <option key={e?.value} value={e?.value}>{e?.label}</option>
            ))}
          </select>
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Report Period</label>
          <select
            value={selectedPeriod}
            onChange={(e) => onPeriodChange(e?.target?.value)}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 min-w-[160px]"
          >
            {REPORT_PERIODS?.map((p) => (
              <option key={p?.value} value={p?.value}>{p?.label}</option>
            ))}
          </select>
        </div>
      </div>
      <button
        onClick={onGenerate}
        disabled={isGenerating}
        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap"
      >
        {isGenerating ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            Generating...
          </>
        ) : (
          <>
            <Icon name="Sparkles" size={16} />
            Generate New Report
          </>
        )}
      </button>
    </div>
  );
};

export default EmirateSelector;
